export const INITIAL_DATA_SHIPPING = Object.freeze({
  id: "", ownshipping_id: "", defaultStore_id: 0, useraccount_id: 0,
  defaultformatnumber: 1, number_shipping: "", date_shipping: "",
  rel_trans_store_id: 0, rel_trans_documentid: "", rel_trans_tradename: "",
  rel_trans_street: "", vehiclestore_id: 0, vehiclestore_licenseplate: "",
  vehiclestore_trailer: "", vehiclestore_documentid: "",
  vehiclestore_defaultdriver: "", opt_tras_store_id: 0,
  opt_tras_documentid: "", opt_tras_tradename: "", opt_tras_street: "",
  dest_tras_store_id: 0, dest_tras_documentid: "", dest_tras_tradename: "",
  dest_tras_street: "", weight: 0, price_weight: 0, service_1: "",
  price_service_1: 0, service_2: "", price_service_2: 0, service_3: "",
  price_service_3: 0, origin_street: "", destine_street: "", workplace: "",
  tax: 0, taxincluded: false, observations: "", signature_driver: "",
  signature_charger: "", signature_inspector: "", formdi_id: 0, ownformdi_id: "",
  totalnetoservice: 0, totalnetoshipping: 0, typeofprice_id: 1,
  typeofprice_namees: "", typeofprice_nameen: "", paymenttype_id: 1,
  paymenttype_code: "", paymenttype_namees: "", paymenttype_nameen: "",
  semitrailertype_id: 0, semitrailertype_namees: "",
  semitrailertype_nameen: "", cranemodel_id: 0, cranemodel_namees: "",
  cranemodel_nameen: "", hours: null, withcrane: false, withoutcrane: false,
  adr: false, others: false, chequeado: false, linesshipping: []
});

export const INITIAL_TYPES_VEHICLES = Object.freeze([
  { id: "", vehiclestore_licenseplate: "" }
]);

export const INITIAL_TYPES_DOCUMENTID = Object.freeze([{
  id: "", documentid: "", tradename: "", typeofprice_id: 1,
  typeofprice_namees: "", typeofprice_nameen: "", paymenttype_id: 1,
  paymenttype_code: "", paymenttype_namees: "", paymenttype_nameen: ""
}]);

export const INITIAL_TYPES_PAYMENT = Object.freeze([
  { id: 1, code: "", namees: "", nameen: "" }
]);

export const INITIAL_TYPES = Object.freeze([{ id: 1, namees: "", nameen: "" }]);
export const INITIAL_WORKPLACE = Object.freeze([{ id: "", workplace: "" }]);

export const INITIAL_ARTICLES = Object.freeze([{
  id: 0, indexrowarticle: 0, shipping_id: 0, substore_id: 0,
  substore_name: "", article_id: 0, article_owncode: "", article_codean: "",
  article_barcode: "", article_codeler: "", article_namees: "",
  article_nameen: "", datepurchase: null, amount: 1, estimatedprice: 0,
  discount: 0, tax: 0, taxincluded: false, total: 0,
  articlestoretypesofprices: []
}]);

export const INITIAL_BUTTONS_ARTICLES = Object.freeze([{
  button_id: 0, indexrowbutton: 0, button_namees: 0, button_nameen: 0,
  button_color: "", article_id: 0, article_owncode: "", article_codean: "",
  article_barcode: "", article_codeler: "", article_namees: "",
  article_nameen: "", article_tax: 0, article_taxincluded: false,
  articlestoretypesofprices: []
}]);

export const buildMenuPermissions = (roles) => {
  const list = (roles ?? []).flatMap((role) => role?.listmenus ?? []);
  const has = (name) => list.some((menu) => menu.name === name);
  return {
    canViewPrice: has('View_Prices_Shipping'),
    canViewFormDI: has('View_FormDi_Shipping'),
    canViewReference: has('View_Reference_Shipping'),
    canViewOptTras: has('View_OptTras_Shipping'),
    canViewCheck: has('SubMenu_Shipping_VIEW_Check'),
    canAutoDeca: has('SubMenu_Shipping_DECA')
  };
};
